import React from 'react';

const Denmark = (props: { width: number }) => {
  return (
    <svg viewBox="0 0 370 280" {...props}>
      <rect fill="#c60c30" height="280" width="370" />
      <rect fill="#fff" height="280" width="40" x="120" />
      <rect fill="#fff" height="40" width="370" y="120" />
    </svg>
  );
};

export default Denmark;
